import { useMediaQuery } from 'react-responsive';

const MAX_TABLET_SCREEN_WIDTH = 780;

const useTabletCheck = () => {
  return useMediaQuery({ query: `(max-width: ${MAX_TABLET_SCREEN_WIDTH}px)` });
};

export default useTabletCheck;
